export default __webpack_public_path__ + "static/media/bootstraparc.923bb1d8.png";